<template>
    <p v-if="attachment.type_id == 1 && attachment.resolution_is_pass" class="resolution-number">{{getRegisterNameBySchema()}}</p>
</template>

<script>
    import { sessionNumberConversion } from "../../../../../helpers/session.helper";
    import { switchToRoman } from "../../../../../helpers/index.conversion";
    export default {
        name: "ResolutionAttachmentPart",
        props: {
            attachment: Object,
            resolution_schema: Object,
            session_number: Number,
        },
        data() {
            return {
            };
        },
        methods: {
            numberConversion() {
                return sessionNumberConversion(this.resolution_schema.session_number_format_id, this.session_number);
            },
            getRegisterNameBySchema() {
                if (this.resolution_schema == undefined || this.resolution_schema == null || this.resolution_schema.schema == "")
                    return this.attachment.name;

                let chunks = this.resolution_schema.schema.toLowerCase().split("/");

                let result = `${this.resolution_schema.docName} `;

                for (let chunk of chunks) {
                    switch (chunk.trim()) {
                        case "np": {
                            if (this.session_number !== undefined && this.session_number !== null && this.session_number !== "" && this.session_number !== 0) {
                                result += `${this.numberConversion()}/`;
                            }
                        } break;
                        case "n": {
                            if (this.attachment.resolution_number !== undefined && this.attachment.resolution_number !== null && this.attachment.resolution_number !== "") {
                                result += `${this.attachment.resolution_number}/`;
                            }
                        } break;
                        case "rr": result += `${this.getYearFromDate(this.attachment.resolution_time)}/`; break;
                        case "rrrr": result += `${this.getFullYearFromDate(this.attachment.resolution_time)}/`; break;
                        case "k": {
                            const cadence = this.getCurrentCadenceNumber();
                            if (cadence !== undefined && cadence !== null && cadence !== "") {
                                result += `${switchToRoman(cadence)}/`; 
                            }
                        }
                        break;
                    }
                }
                return result.slice(0, -1);
            },
            getFullYearFromDate(value) {
                var date = new Date(value);
                return date.getFullYear();
            },
            getYearFromDate(value) {
                var date = new Date(value);
                return date.getFullYear().toString().substr(-2);
            },
            getCurrentCadenceNumber(){
                return this.$store.state.settings.cadenceNumber;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .resolution-number {
        color: grey;
        font-size: 12px;
        font-weight: 400;
    }
</style>